import { render, staticRenderFns } from "./MdEditAllergySetup.vue?vue&type=template&id=91ea6614&"
import script from "./MdEditAllergySetup.vue?vue&type=script&lang=js&"
export * from "./MdEditAllergySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports